/**
 * Top-down sketch of a finish: the timing phone stands on the finish line's
 * extension off the side of the course, a cone marks the far end of the line,
 * and the bib phone faces runners a few metres before the line.
 */
export function SetupDiagram({ second = false }: { second?: boolean }) {
  return (
    <svg viewBox="0 0 720 384" role="img" aria-label="Top-down view of a finish: the timing phone in line with the finish line, a cone at the far end of the line, and a bib phone facing runners a few metres before the line" style={{ width: '100%', height: 'auto', maxWidth: 720 }}>
      <defs>
        <marker id="sd-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
          <path d="M0,0 L10,5 L0,10 z" fill="currentColor" />
        </marker>
      </defs>
      <style>{`
        .sd-road { fill: var(--line-soft, #e8e8e4); }
        .sd-edge { stroke: var(--ink-2, #555); stroke-width: 2; }
        .sd-line { stroke: #ff5a1f; stroke-width: 6; }
        .sd-sight { stroke: #ff5a1f; stroke-width: 2; stroke-dasharray: 6 6; }
        .sd-view { fill: #2f6fde; opacity: 0.12; }
        .sd-phone { fill: var(--ink, #15181c); }
        .sd-cone { fill: #ff8a00; stroke: #b35c00; stroke-width: 2; }
        .sd-text { font: 600 15px system-ui, sans-serif; fill: var(--ink, #15181c); }
        .sd-small { font: 13px system-ui, sans-serif; fill: var(--ink-2, #555); }
        .sd-runner { fill: #2f6fde; }
      `}</style>
      {/* Course: runners travel left to right */}
      <rect className="sd-road" x="20" y="120" width="680" height="140" rx="6" />
      <line className="sd-edge" x1="20" y1="120" x2="700" y2="120" />
      <line className="sd-edge" x1="20" y1="260" x2="700" y2="260" />
      <g color="#2f6fde">
        <line x1="50" y1="190" x2="190" y2="190" stroke="currentColor" strokeWidth="3" markerEnd="url(#sd-arrow)" />
      </g>
      <text className="sd-small" x="50" y="178">
        runners
      </text>
      <circle className="sd-runner" cx="250" cy="160" r="9" />
      <circle className="sd-runner" cx="285" cy="215" r="9" />
      <circle className="sd-runner" cx="330" cy="180" r="9" />

      {/* Finish line, its extension to the timing phone, and the cone at the far end */}
      <line className="sd-sight" x1="420" y1="50" x2="420" y2="120" />
      <line className="sd-sight" x1="420" y1="260" x2="420" y2="326" />
      <line className="sd-line" x1="420" y1="120" x2="420" y2="260" />
      <text className="sd-text" x="430" y="140">
        finish line
      </text>
      <polygon className="sd-cone" points="420,90 409,114 431,114" />
      <text className="sd-small" x="438" y="108">
        cone at the far end of the line
      </text>

      {/* Timing phone, in line with the finish, looking across the course */}
      <path className="sd-view" d="M420,328 L330,120 L510,120 Z" />
      <rect className="sd-phone" x="410" y="328" width="20" height="30" rx="4" />
      <text className="sd-text" x="398" y="340" textAnchor="end">
        timing phone
      </text>
      <text className="sd-small" x="398" y="357" textAnchor="end">
        exactly on the line’s extension,
      </text>
      <text className="sd-small" x="398" y="373" textAnchor="end">
        3–6 m back from the course
      </text>

      {/* Bib phone past the line, facing back at approaching runners */}
      <path className="sd-view" d="M632,292 L340,258 L340,150 Z" opacity="0.7" />
      <rect className="sd-phone" x="617" y="282" width="30" height="20" rx="4" transform="rotate(-20 632 292)" />
      <text className="sd-text" x="704" y="330" textAnchor="end">
        bib phone
      </text>
      <text className="sd-small" x="704" y="347" textAnchor="end">
        faces runners as they approach,
      </text>
      <text className="sd-small" x="704" y="363" textAnchor="end">
        within ~4 m of them
      </text>

      {second && (
        <>
          <rect className="sd-phone" x="410" y="14" width="20" height="30" rx="4" />
          <text className="sd-text" x="440" y="34">
            2nd timing phone (big fields)
          </text>
        </>
      )}
    </svg>
  );
}
